import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ThankYou } from './pages/ThankYou';
import { Cases } from './pages/Cases';
export function App() {
  useEffect(() => {
    document.title = 'Cases On Command';
  }, []);
  return <BrowserRouter data-id="element-0">
      <Helmet data-id="element-1">
        <script data-id="element-2">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MPVTBBX2');`}
        </script>
      </Helmet>
      <div className="bg-black text-white min-h-screen w-full" data-id="element-3">
        <noscript data-id="element-4">
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MPVTBBX2" height="0" width="0" style={{
          display: 'none',
          visibility: 'hidden'
        }} data-id="element-5" />
        </noscript>
        <Header data-id="element-6" />
        <main data-id="element-7">
          <Routes data-id="element-8">
            <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />
            <Route path="/thankyou" element={<ThankYou data-id="element-12" />} data-id="element-11" />
            <Route path="/cases" element={<Cases data-id="element-14" />} data-id="element-13" />
          </Routes>
        </main>
        <Footer data-id="element-15" />
      </div>
    </BrowserRouter>;
}